import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default class ProductsController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore(this.props.store);
        this.state = {
            products: this.store.items,
            paging: this.store.paging,
            sort: this.store.sorting,
            status: 'idle',
            productView: "ProductBrowserViewsThumbView",
        };

        this.store.listen(this.onStoreChange.bind(this));
    }

    onStoreChange(products, paging, sorting, filters, status) {
        this.setState({ products, paging, sort: sorting, status });
    }

    render() {
        const ProductsView = ComponentRegistry.get(this.props.view);

        return (
          <ProductsView
            {...this.props}
            {...this.state}
            onChangePage={value => this.store.switchToPage(value)}
            onSort={value => this.store.sort(value)}
            onChangeView={value => this.setState({ productView: value })}
            onChangeItemsPerPage={value => this.store.itemsPerPage(value)}
          />
        );
    }
}

ProductsController.propTypes = {
    view: PropTypes.string.isRequired,
    store: PropTypes.string.isRequired,
};

ProductsController.defaultProps = {
    view: "ProductBrowserViewsProductsView",
    store: "ProductBrowserStore",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductBrowser/Controllers/ProductsController.jsx